import { useEffect } from 'react';
import { useSearchParams, useLocation, useNavigate } from 'react-router-dom';
import { useAstrologerChat, type ChatTarget } from '../../hooks/useAstrologerChat';
import { ChatConversationView } from './ChatConversationView';

/** `?thread=<id>` → a saved conversation; otherwise a new one (`?chartId`, `?surface`, `?seedRef`). */
export function chatTargetFromParams(params: URLSearchParams): ChatTarget {
  const threadId = params.get('thread');
  if (threadId) return { kind: 'thread', threadId };
  const chartId = params.get('chartId') || null;
  return {
    kind: 'new',
    chartId,
    surface: params.get('surface') || (chartId ? 'chart' : 'natal'),
    seedRef: params.get('seedRef') || null,
  };
}

export function AstrologerChat(): JSX.Element {
  return <ChatScreen key={useLocation().key} />;
}
function ChatScreen(): JSX.Element {
  const [params] = useSearchParams();
  const target = chatTargetFromParams(params);
  const chat = useAstrologerChat(target);
  const navigate = useNavigate();
  useEffect(() => {
    if (chat.redirectCourseThreadId) void navigate(`/course/chat?thread=${encodeURIComponent(chat.redirectCourseThreadId)}`, { replace: true });
  }, [chat.redirectCourseThreadId, navigate]);
  return <ChatConversationView chat={chat} target={target} />;
}
